// src/pages/WarehousePage.js

import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import PageHeader from "common/PageHeader";
import Footer from "common/Footer";
import WarehouseItemList from "common/Warehouse/WarehouseItemList";
import WarehouseItemUpload from "common/Warehouse/WarehouseItemUpload";
import WarehouseItemModal from "common/Warehouse/WarehouseItemModal";
import { Box, Fade, IconButton, Tooltip, Button } from "@mui/material";
import { Add as AddIcon, Refresh as RefreshIcon } from "@mui/icons-material";
import { useSnackbar } from "context/SnackbarContext";
import { useLanguage } from "context/LanguageContext";

const WarehousePage = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showSnackbar = useSnackbar();
  const { t } = useLanguage();

  const handleUploadSuccess = () => {
    setRefreshTrigger((prev) => !prev);
    showSnackbar(t("warehouseItemsUploadedSuccessfully"), "success");
  };

  const handleRefresh = () => {
    setIsRefreshing(true);
    setRefreshTrigger((prev) => !prev);
  };

  const handleRefreshComplete = (succeeded) => {
    if (isRefreshing && succeeded) showSnackbar(t("warehouseListRefreshed"), "success");
    setIsRefreshing(false);
  };

  const handleAddItemClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSuccess = () => {
    setRefreshTrigger((prev) => !prev);
    // Snackbar message is handled in the modal
  };

  return (
    <DashboardLayout>
      <MDBox pt={3} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card
              sx={{
                overflow: "hidden",
                border: "1px solid",
                borderColor: "divider",
                boxShadow: "none",
              }}
            >
              <PageHeader
                title={t("warehouseManagement")}
                actions={
                  <>
                    <Tooltip title={t("addItem")}>
                      <Button
                        variant="contained"
                        color="white"
                        startIcon={<AddIcon />}
                        onClick={handleAddItemClick}
                      >
                        {t("addItem")}
                      </Button>
                    </Tooltip>
                    <Tooltip title={t("refreshList")}>
                      <IconButton
                        color="info"
                        onClick={handleRefresh}
                        sx={{
                          transform: isRefreshing ? "rotate(180deg)" : "none",
                          transition: "transform 0.5s ease-in-out",
                        }}
                      >
                        <RefreshIcon />
                      </IconButton>
                    </Tooltip>
                    <WarehouseItemUpload onUploadSuccess={handleUploadSuccess}>
                      {t("uploadItems")}
                    </WarehouseItemUpload>
                  </>
                }
              />

              <Fade in={!isRefreshing} timeout={500}>
                <Box>
                  <WarehouseItemList
                    refreshTrigger={refreshTrigger}
                    onRefreshComplete={handleRefreshComplete}
                  />
                </Box>
              </Fade>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <WarehouseItemModal
        open={isModalOpen}
        handleClose={handleCloseModal}
        onSuccess={handleSuccess}
        item={null}
      />
      <Footer />
    </DashboardLayout>
  );
};

export default WarehousePage;
